import { Component, OnInit, ViewChild, signal } from '@angular/core';
import { CabinetService } from '../services/cabinet.service';
import {MatDialog} from '@angular/material/dialog';
import { CabinetListModalComponent } from 'src/app/shared/cabinet-list-modal/cabinet-list-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { StoresService } from '../services/stores.service';
import { PaginationComponent } from '../common/pagination/pagination.component';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { timestampFormat } from '../../../app/config/moment';
import { DesktopDevicesComponent } from '../stores/desktop-devices/desktop-devices.component';
import { HandheldDevicesComponent } from '../stores/handheld-devices/handheld-devices.component';

 
@Component({
  standalone: true,
  selector: 'app-cabinet',
  imports: [PaginationComponent, CommonModule, FormsModule, DesktopDevicesComponent, HandheldDevicesComponent],
  templateUrl: './cabinet.component.html',
  styleUrls: ['./cabinet.component.scss', '../../app.component.scss']
})
export class CabinetComponent implements OnInit {
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  activeTab: string = 'cabinets';
  public totalPages: number = 0;
  public currentPage: number = 1; 

  public timestampFormat = timestampFormat;

  public storeDetails: any;
  public cabinets: any;
  public totalCabinets: number = 0;

  public currentStoreId: string;
  public deviceType: string = "cabinet";

  public searchInput: string = ""; 
  public encodedSearchInput: string = "";

  public isCabinets = true;
  public isFilter = false;

  public isFilterResult = true;

  public isStore = false;
  public isSearch = false;

  public updatedAtSortValue:string = "";
  public stockCountSortValue :string = "";
  public missedCountSortValue :string = "";
  public expiryCountSortValue :string = "";

  public orderBy:string = "asc";
  public storeId: string = '';
  deviceId: any;

  constructor(
    public cabinetService: CabinetService, 
    public storeService: StoresService, 
    public dialog: MatDialog, 
    private router: Router,
    public route: ActivatedRoute,
    public location: Location
  ) { } 

  popupValue = signal('');
 
  ngOnInit() {
    this.route.params.subscribe(routeParams => {
      this.currentStoreId = routeParams.id;
      this.getStoreDetails();
      this.cabinetListService(this.currentStoreId, this.deviceType);
    });
  }
  

  getStoreDetails(){
    this.storeService.getStoreDetails(this.currentStoreId).subscribe(res => { 
      if (res.data) {
        this.isStore = true
        this.storeDetails = res.data;
      }else{
        this.isStore = false
      }       
    });
  }

  navigateToDetailPage(id) {
    this.router.navigate(['/home/stocks/cabinets/' + id]);
  }

  goBack(){
    this.location.back();
  }

  cabinetListService(
    storeId: string, 
    deviceType: string = "", 
    page: string = "", 
    search :string = "",
    stockCountSort :string = "",
    missedCountSort :string = "",
    expiryCountSort :string = "",
    lastUpdatedAt :string = "",
  ){
    this.cabinetService.getStoreCabinets(
      storeId, 
      deviceType, 
      page, 
      search,
      stockCountSort,
      missedCountSort,
      expiryCountSort,
      lastUpdatedAt
    ).subscribe(res => { 
      if (res.data.data.length !== 0) {
        this.totalCabinets = res.data.total;
        this.totalPages = res.data.last_page;
        this.cabinets = res.data.data;

        if (this.isSearch || this.isFilter) {
          this.isFilterResult = true;
        }else{
          this.isCabinets = true;
        }
      }else{
        if (this.isSearch || this.isFilter) {
          this.isFilterResult = false;
        }else{
          this.isCabinets = false;
        }

        this.totalCabinets = 0;
        this.totalPages = 0;
      }
    });
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) {
        this.updatedAtSortValue = "";
        this.stockCountSortValue = "";
        this.missedCountSortValue = "";
        this.expiryCountSortValue = "";
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.cabinetListService(this.currentStoreId, this.deviceType, "", this.encodedSearchInput);
    }
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.searchInput = "";
      this.stockCountSortValue = "";
      this.missedCountSortValue = "";
      this.expiryCountSortValue = "";
      this.updatedAtSortValue = "";
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.cabinetListService(this.currentStoreId, this.deviceType);
    }
  }

  stockCountSort(){
    this.isFilter = true;

    if (this.stockCountSortValue === "asc") {
      this.stockCountSortValue = "desc";
    }else{
      this.stockCountSortValue = this.orderBy;
    }

    this.onFilterChange();    
  }

  missedCountSort(){
    this.isFilter = true;

    if (this.missedCountSortValue === "asc") {
      this.missedCountSortValue = "desc";
    }else{
      this.missedCountSortValue = this.orderBy;
    }

    this.onFilterChange();    
  }

  expiryCountSort(){
    this.isFilter = true;

    if (this.expiryCountSortValue === "asc") {
      this.expiryCountSortValue = "desc";
    }else{
      this.expiryCountSortValue = this.orderBy;
    }

    this.onFilterChange();    
  }

  updatedAtSort(){
    this.isFilter = true;

    if (this.updatedAtSortValue === "asc") {
      this.updatedAtSortValue = "desc";
    }else{
      this.updatedAtSortValue = this.orderBy;
    }

    this.onFilterChange();    
  }

  getQueryPage($event: number){
    this.currentPage = $event;    
    this.cabinetListService(this.currentStoreId, this.deviceType, `${this.currentPage}`, this.encodedSearchInput);
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.cabinetListService(this.currentStoreId, this.deviceType, "", this.encodedSearchInput, this.stockCountSortValue, this.missedCountSortValue, this.expiryCountSortValue, this.updatedAtSortValue);
  }

  openDialog(cabinetName : any, type: string, cabinetId: any): void {
    const dialogRef = this.dialog.open(CabinetListModalComponent, {
      data: {
        name: cabinetName,
        type: type,
        cabinet_id: cabinetId,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cabinetListService(this.currentStoreId, this.deviceType);     
      }
    });
  }

  openPopup(event){
    let openedPopup = document.getElementsByClassName("dots-popup");

    let targetedElement = event.target.closest('td');
    let popupDiv = targetedElement.getElementsByClassName("dots-popup")[0];

    Array.from(openedPopup).forEach((el)=>{
      if (el !== popupDiv) {
        el.classList.remove('active');
      }
    })

    popupDiv.classList.toggle("active");
    event.stopPropagation();

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }

  // setActiveTab(storeId: string): string {
  //   switch (this.activeTab) {
  //     case 'cabinets':
  //       return `/home/stores/${storeId}/cabinets`;
  //     case 'handheld':
  //       return `/home/stores/${storeId}/handheld`;
  //     default:
  //       return `/home/stores/${storeId}/devices`;
  //   }
  // }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    let route: string;
    switch (tab) {
      case 'cabinets':
        route = `/home/stores/${this.storeId}/cabinets`;
        break;
      case 'desktop':
        route = `/home/stores/${this.storeId}/devices`;
        break;
      case 'handheld':
        route = `/home/stores/${this.storeId}/handheld`;
        break;
      default:
        // route = `/home/stores/${this.storeId}/cabinets`;
    }
    this.router.navigate([route]);
  }
}
